import { useQuery } from "@tanstack/react-query";
import type { ProductType } from "@/api_client";
import type { Locales } from "@/graphql/generated";
import { entryContentExternalQueryOptions } from "../queryOptions/entryContentExternalQueryOptions";

type UseEntryContentExternalParams<P extends ProductType> = {
  product: P;
  language: Locales;
  appPathPrefix?: string;
};

export const useEntryContentExternal = <P extends ProductType>({
  product,
  language,
  appPathPrefix,
}: UseEntryContentExternalParams<P>) => {
  return useQuery(
    entryContentExternalQueryOptions({
      product,
      language,
      appPathPrefix,
    }),
  );
};
